import React from "react";

import {
  faqBrands,
  faqGeneral,
  faqLevels,
  faqOnline,
  faqPresencial,
  faqRules,
} from "../../utils/rewards";
import Page from "../global/Page";
import Accordion from "../global/Accordion";
import { navigate } from "@reach/router";

const RewardsFAQ = () => {
  return (
    <Page
      verticalAlign={"align-items-start"}
      title="Preguntas Frecuentes TBM Rewards"
    >
      <div className="my-5">
        <h3
          className="bold large item__title me-2"
          style={{ color: "#1D1D1B" }}
        >
          Preguntas Generales sobre TBM Rewards
        </h3>
        <Accordion id="faq-general" items={faqGeneral} />
      </div>

      <div className="my-5">
        <h3
          className="bold large item__title me-2"
          style={{ color: "#1D1D1B" }}
        >
          Funcionamiento del Programa (Modalidad Presencial)
        </h3>
        <Accordion id="faq-presencial" items={faqPresencial} />
      </div>

      <div className="my-5">
        <h3
          className="bold large item__title me-2"
          style={{ color: "#1D1D1B" }}
        >
          Funcionamiento del Programa (Modalidad En Línea)
        </h3>
        <Accordion id="faq-online" items={faqOnline} />
      </div>

      <div className="my-5">
        <h3
          className="bold large item__title me-2"
          style={{ color: "#1D1D1B" }}
        >
          Sobre los Niveles y las Recompensas
        </h3>
        <Accordion id="faq-levels" items={faqLevels} />
      </div>

      <div className="my-5">
        <h3
          className="bold large item__title me-2"
          style={{ color: "#1D1D1B" }}
        >
          Sobre las Marcas Colaboradoras
        </h3>
        <Accordion id="faq-brands" items={faqBrands} />
      </div>

      <div className="my-5">
        <h3
          className="bold large item__title me-2"
          style={{ color: "#1D1D1B" }}
        >
          Reglas del Programa
        </h3>
        <Accordion id="faq-rules" items={faqRules} />
      </div>
      <div className="container-fluid text-center pb-5">
        <button
          onClick={() => navigate("/rewards")}
          className="feat-btn mx-auto btn rewards-gradient"
        >
          <span className="text-white ">IR A TBM REWARDS</span>
        </button>
      </div>
    </Page>
  );
};

export default RewardsFAQ;
